// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopupModals {
    display: flex;
    justify-content: center;
}

.unsavedPopupBody {
    width: 391px;
    height: 123px;
    border-radius: var(--radius-xs, 4px);
    box-shadow: 0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03);
    background-color: #fff;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 24px;
    margin: 8px;
    font: 400 13px/20px Inter, sans-serif;
}


.modal-header-h2 {
    color: #101828;
    font: 600 16px/28px Inter, sans-serif;
    font-style: 'semi-bold';
}

.modal-header-p {
    color: #475467;
    font: 400 13px/20px Inter, sans-serif;
    font-style: 'regular';
    line-height: 154%;
    margin-top: 4px;
}

.btngroup1 {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    margin-top: 10px;
}


.discardLabel {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 12px;
    font: 400 13px/24px Inter, sans-serif;
    color: #344054;
    background-color: #fff;
    cursor: pointer;
}

.createNewDepartmentPopupBody {
    display: flex;
    flex-direction: column;
    padding: 24px;
    margin: 4px;
    width: 484px;
    height: 239px;
    border-radius: var(--radius-xs, 4px);
    box-shadow: 0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03);
    background-color: var(--Colors-Background-bg-primary, #fff);
    justify-content: center;
    font: 400 13px/20px Inter, sans-serif;
    
}

.modal-header {
    display: flex;
    align-items: start;
    width: 484px;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 20px;
}

.modal-header-title {
    margin-top: 7px;
}

.modal-header-title label {
    color: #344054;
    font: bold 16px/30px Inter, sans-serif;
}

.modal-content {
    margin-top: 20px;
}

.labelname {
    color: #344054;
    font: 600 13px/154% Inter, sans-serif;
}

.inputname {
    border: 2px solid #D0D5DD;
    border-radius: 8px;
    width: 454px;
    height: 34px auto;
    resize: horizontal;
    padding: 5px 8px;
}

.inputname:focus {
    outline: none;
    border-color: #AEBDBD;
}

.createbtngroup {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    margin-top: 50px;
  
}

.button-secondary {
    width: 124px;
    height: 34px;
    border-radius: 8px;
    border: 2px solid #D0D5DD;
    background-color: var(
      --Component-colors-Components-Buttons-Secondary-button-secondary-bg,
      #fff
    );
    color: var(
      --Component-colors-Components-Buttons-Secondary-button-secondary-fg,
      #344054
    );
    cursor: pointer;
  }

  .button-primary2 {
    width: 120px;
    height: 34px;
    border-radius: 8px;
    border: 2px solid #7F56D9;
    background-color: var(
      --Component-colors-Components-Buttons-Primary-button-primary-bg,
      #7f56d9
    );
    color: var(
      --Component-colors-Components-Buttons-Primary-button-primary-fg,
      #fff
    );
    cursor: pointer;
  }

.button-primary2:hover {
    background-color: #7f56d9;
}

.button-primary2:active {
    background-color: #7f56d9;
    box-shadow: none;
}

.button-primary2:focus-visible {
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    outline: none;
}

.button-primary2.disabled {
    opacity: 0.4;
    cursor: not-allowed;
    box-shadow: none;
    &:hover {
    background-color: #7f56d9;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/PeopleComponents/PopupModal.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,8FAA8F;IAC9F,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,qCAAqC;AACzC;;;AAGA;IACI,cAAc;IACd,qCAAqC;IACrC,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,qCAAqC;IACrC,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,qCAAqC;IACrC,cAAc;IACd,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,8FAA8F;IAC9F,2DAA2D;IAC3D,uBAAuB;IACvB,qCAAqC;;AAEzC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;;AAEpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB;;;KAGC;IACD;;;KAGC;IACD,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB;;;KAGC;IACD;;;KAGC;IACD,eAAe;EACjB;;AAEF;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,kDAAkD;IAClD,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB;IACA,yBAAyB;IACzB;AACJ","sourcesContent":[".PopupModals {\n    display: flex;\n    justify-content: center;\n}\n\n.unsavedPopupBody {\n    width: 391px;\n    height: 123px;\n    border-radius: var(--radius-xs, 4px);\n    box-shadow: 0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03);\n    background-color: #fff;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    padding: 24px;\n    margin: 8px;\n    font: 400 13px/20px Inter, sans-serif;\n}\n\n\n.modal-header-h2 {\n    color: #101828;\n    font: 600 16px/28px Inter, sans-serif;\n    font-style: 'semi-bold';\n}\n\n.modal-header-p {\n    color: #475467;\n    font: 400 13px/20px Inter, sans-serif;\n    font-style: 'regular';\n    line-height: 154%;\n    margin-top: 4px;\n}\n\n.btngroup1 {\n    display: flex;\n    justify-content: flex-end;\n    gap: 20px;\n    margin-top: 10px;\n}\n\n\n.discardLabel {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 6px 12px;\n    font: 400 13px/24px Inter, sans-serif;\n    color: #344054;\n    background-color: #fff;\n    cursor: pointer;\n}\n\n.createNewDepartmentPopupBody {\n    display: flex;\n    flex-direction: column;\n    padding: 24px;\n    margin: 4px;\n    width: 484px;\n    height: 239px;\n    border-radius: var(--radius-xs, 4px);\n    box-shadow: 0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03);\n    background-color: var(--Colors-Background-bg-primary, #fff);\n    justify-content: center;\n    font: 400 13px/20px Inter, sans-serif;\n    \n}\n\n.modal-header {\n    display: flex;\n    align-items: start;\n    width: 484px;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 20px;\n}\n\n.modal-header-title {\n    margin-top: 7px;\n}\n\n.modal-header-title label {\n    color: #344054;\n    font: bold 16px/30px Inter, sans-serif;\n}\n\n.modal-content {\n    margin-top: 20px;\n}\n\n.labelname {\n    color: #344054;\n    font: 600 13px/154% Inter, sans-serif;\n}\n\n.inputname {\n    border: 2px solid #D0D5DD;\n    border-radius: 8px;\n    width: 454px;\n    height: 34px auto;\n    resize: horizontal;\n    padding: 5px 8px;\n}\n\n.inputname:focus {\n    outline: none;\n    border-color: #AEBDBD;\n}\n\n.createbtngroup {\n    display: flex;\n    justify-content: flex-end;\n    gap: 20px;\n    margin-top: 50px;\n  \n}\n\n.button-secondary {\n    width: 124px;\n    height: 34px;\n    border-radius: 8px;\n    border: 2px solid #D0D5DD;\n    background-color: var(\n      --Component-colors-Components-Buttons-Secondary-button-secondary-bg,\n      #fff\n    );\n    color: var(\n      --Component-colors-Components-Buttons-Secondary-button-secondary-fg,\n      #344054\n    );\n    cursor: pointer;\n  }\n\n  .button-primary2 {\n    width: 120px;\n    height: 34px;\n    border-radius: 8px;\n    border: 2px solid #7F56D9;\n    background-color: var(\n      --Component-colors-Components-Buttons-Primary-button-primary-bg,\n      #7f56d9\n    );\n    color: var(\n      --Component-colors-Components-Buttons-Primary-button-primary-fg,\n      #fff\n    );\n    cursor: pointer;\n  }\n\n.button-primary2:hover {\n    background-color: #7f56d9;\n}\n\n.button-primary2:active {\n    background-color: #7f56d9;\n    box-shadow: none;\n}\n\n.button-primary2:focus-visible {\n    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n    outline: none;\n}\n\n.button-primary2.disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n    box-shadow: none;\n    &:hover {\n    background-color: #7f56d9;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
